export default "__VITE_ASSET__W0So5AIO__"